import { useAuthStore } from '@/stores/auth.store';
import { storeToRefs } from 'pinia';
import { computed } from 'vue';

/** After shaking hands with this many players, the handshake and play buttons are known by their icons. */
const LEARNED_AFTER_PARTNERS = 2;

/**
 * Whether the handshake and play buttons still carry their words. Read from
 * the account, not the phone, so a new phone does not start over and a new
 * player sees the words everywhere until they have used them.
 */
export function useCtaLabels() {
  const { userDetails } = storeToRefs(useAuthStore());

  // Unknown until the account loads, and then the icons stay alone rather than flash words.
  const isLearning = computed(() => {
    const partnerIds = userDetails.value?.handshakePartnerIds;
    return !!partnerIds && partnerIds.length < LEARNED_AFTER_PARTNERS;
  });

  return { isLearning };
}
